import { apiGet, apiPost, unwrapList } from './helpers'

const PATH = 'weightloss/prices'

export default {
  list: params => apiGet(PATH, params).then(unwrapList),
  create: data => apiPost(PATH, data),
  /** @deprecated Append-only: el backend rechaza PUT. Usar create con nueva effective_date. */
}
